import Grid from '@components/grid';
import Button from '@components/ui/button';
import Container from '@components/ui/container';
import Text from '@components/ui/text';
import React, { ReactElement } from 'react';
import { ASSET_URL } from 'lib/constants';
import Image from 'next/image';
import CMSLink from '@components/CMSLink';

export default function GenericCTA(block: any): ReactElement {
  const { title, description, link, options } = block;

  return (
    <Container>
      <div
        className={`relative p-8 md:p-12 lg:p-20 flex flex-col justify-center items-center ${
          options.theme === 'dark' ? 'bg-black' : 'bg-accent-1'
        }`}
      >
        <div className="absolute inset-0 z-10 opacity-50 bg-gradient-to-r from-transparent to-telesoft mix-blend-soft-light" />
        <Grid className="gap-8 z-20">
          <div className="col-span-4">
            <Text
              variant="subHeading"
              className={`${
                options.theme === 'dark' ? 'text-white' : 'text-black'
              }`}
            >
              {title}
            </Text>
          </div>

          <div
            className={`col-span-4 lg:pt-2 pb-2 lg:mb-0 border-b ${
              options.theme === 'dark' ? 'border-white' : 'border-black'
            }`}
          >
            <Text
              variant="body"
              className={`${
                options.theme === 'dark' ? 'text-white' : 'text-black'
              }`}
            >
              {description}
            </Text>
          </div>

          <div className="col-span-4 flex items-end">
            <CMSLink {...link} className="w-full">
              <Button
                variant={options.theme === 'dark' ? 'flatLight' : 'flat'}
                invert={options.theme === 'dark' ? true : false}
                className={`w-full ${
                  options.theme === 'dark' ? 'text-white' : 'text-black'
                }`}
              >
                {link.label}
              </Button>
            </CMSLink>
          </div>
        </Grid>

        {options.image && (
          <Image
            src={ASSET_URL + '/' + options.image.filename}
            layout="fill"
            loading="lazy"
            alt={options?.image?.alt || ''}
            className="object-cover object-center opacity-20"
          />
        )}
      </div>
    </Container>
  );
}
